export const floorClickableRegions = [
  { floor: 1, coords: "50,50,250,50,250,150,50,150" },
  { floor: 2, coords: "50,160,250,160,250,250,50,250" },
  { floor: 3, coords: "50,260,250,260,250,350,50,350" },
  { floor: 4, coords: "50,360,250,360,250,450,50,450" },
  { floor: 5, coords: "50,460,250,460,250,550,50,550" },
  { floor: 6, coords: "616,223,867,240,985,230,1355,264,1476,257,2106,311,2106,542,1504,443,1422,464,1226,423,1131,440,968,427,847,406,620,366" },
  { floor: 7,coords: "50,660,250,660,250,750,50,750" },
  { floor: -1, co0rds: "50,760,250,760,250,850,50,850" },
];
